import { HandClapIcon } from './HandClapIcon';

/**
 * author: Michael Irigoyen
 * id 8FEFA10A-395F-47B9-B5B9-0040905E9E1F
 * name hand-clap
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-clap.svg
 * tags
 */
export const ApplauseIcon = HandClapIcon;
export default ApplauseIcon